import React from "react";
import { useLocation } from "react-router-dom";
import { XO_INK, XO_PAPER } from "./xoConvergenceBrand";
import { isPublicCinematicShellPath } from "../navigation/navConfig";
import { XONotFoundSurface } from "./XONotFoundSurface";
import { XOPublicShell } from "./XOPublicShell";
import XOGamesAlphaPage from "../pages/XOGamesAlphaPage";
import XOGamesSecondLifeProofPage from "../pages/XOGamesSecondLifeProofPage";

/**
 * Unknown paths: designed ink fallback — never a blank screen.
 * Public cinematic URLs stay full-bleed; internal URLs keep sidebar + ink content column.
 *
 * M2 xo.games Alpha is intentionally routed here as one bounded development surface so
 * the large application route table stays untouched until the Alpha proves its shape.
 */
export function XOCatchAllRoute() {
  const { pathname } = useLocation();
  const hostname =
    typeof globalThis !== "undefined" && "location" in globalThis
      ? (globalThis as unknown as { location: { hostname: string } }).location.hostname
      : "";

  if (pathname === "/games" || pathname === "/games/") {
    return (
      <XOPublicShell>
        <XOGamesAlphaPage />
      </XOPublicShell>
    );
  }

  if (pathname === "/games/proof/game-gta-v-x360-m1-001") {
    return (
      <XOPublicShell>
        <XOGamesSecondLifeProofPage />
      </XOPublicShell>
    );
  }

  const cinematic = isPublicCinematicShellPath(pathname, hostname);

  if (cinematic) {
    return (
      <XOPublicShell>
        <XONotFoundSurface />
      </XOPublicShell>
    );
  }

  return (
    <div
      style={{
        flex: 1,
        alignSelf: "stretch",
        minWidth: 0,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        background: XO_INK,
        color: XO_PAPER,
        boxSizing: "border-box",
      }}
    >
      <XONotFoundSurface embedded />
    </div>
  );
}
